import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FilterGroup, LookupOption } from './grid-types';
import { GridApiService } from './services/grid-api.service';
import { Page } from '@syncfusion/ej2-angular-grids';

@Component({
  selector: 'wc-lookup-editor',
  standalone: false,
  styleUrls: ['./grid-theme.css'],
  template: `
    <select class="wcg__select wcg__select--lookup"
          [disabled]="disabled"
          [(ngModel)]="value"
          (ngModelChange)="valueChange.emit($event)">
    <option *ngIf="!required" [ngValue]="null">--</option>
    <option *ngFor="let o of options" [ngValue]="o.value">{{o.label}}</option>
  </select>

  `
})
export class WcLookupEditorComponent implements OnChanges {
  @Input() gridKey!: string;
  @Input() lookupKey!: string;
  @Input() filter?: FilterGroup|null;
  @Input() value: any;
  @Input() lookups?: Record<string, LookupOption[]>;

  @Input() required = false;
  @Input() disabled = false;

  @Output() valueChange = new EventEmitter<any>();

  options: LookupOption[] = [];

  constructor(private api: GridApiService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.gridKey || !this.lookupKey) return;

    // Only reload options when the inputs that drive the option list change.
    // Ignore value changes — the user picking a selection shouldn't re-fetch.
    if (!changes['gridKey'] && !changes['lookupKey'] && !changes['filter'] && !changes['lookups']) return;

    if (this.lookups) {
      const cached = this.lookups[this.lookupKey];
      if (cached) {
        this.options = cached;
        return;
      }
    }

    this.api.lookup(this.gridKey, this.lookupKey, { filter: this.filter ?? null, take: 200 }, (x: LookupOption[]) => {
      this.options = x;
    });
  }
}
